import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import {Auth0Plugin, getInstance} from '@/services/auth0/index';

Vue.config.productionTip = false

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
    domain: process.env.VUE_APP_AUTH0_DOMAIN,
    clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
    audience: process.env.VUE_APP_AUTH0_AUDIENCE,
    onRedirectCallback: async appState => {

        const auth0 = getInstance()
        const jwt = await auth0.getTokenSilently()
        console.debug('accessToken:', jwt)

        router.push(
            appState && appState.targetUrl
                ? appState.targetUrl
                : window.location.pathname
        );
    }
});

new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')
